import { css, styled } from '../../hooks/theme';

import { Columns, Spacing, Tokens } from '../../types';
import { AlignItems, JustifyContent } from './Grid.types';

interface GridContainerProps {
  xs?: Columns;
  sm?: Columns;
  md?: Columns;
  lg?: Columns;
  spacing?: Spacing;
  container?: boolean;
  item?: boolean;
  justifyContent?: JustifyContent;
  alignItems?: AlignItems;
}
const calcRemoveSpacingPadding = (columns: number, spacing: number) =>
  (spacing / 12) * (12 - columns);

const getCssSizeScreen = (columns: number, removePadding) => css`
  width: calc(${(columns / 12) * 100}% - ${removePadding}px);
  max-width: calc(${(columns / 12) * 100}% - ${removePadding}px);
`;
export const GridContainer = styled.div<GridContainerProps>`
  ${props => {
    const spacing = props.theme.spacing[props.spacing] ?? 0;
    if (props.container) {
      return css`
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        gap: ${(spacing ?? 0) / 16}rem;
        ${props.justifyContent &&
        css`
          justify-content: ${props.justifyContent};
        `}
        ${props.alignItems &&
        css`
          align-items: ${props.alignItems};
        `}
      `;
    } else if (props.item) {
      const removeXsPadding = calcRemoveSpacingPadding(props.xs, spacing);
      const removeSmPadding = calcRemoveSpacingPadding(props.sm, spacing);
      const removeMdPadding = calcRemoveSpacingPadding(props.md, spacing);
      const removeLgPadding = calcRemoveSpacingPadding(props.lg, spacing);
      return css`
        display: block;
        ${getCssSizeScreen(props.xs, removeXsPadding)}
        ${removeSmPadding &&
        css`
          @media screen and (min-width: ${Tokens.breakpoints.tablet}px) {
            ${getCssSizeScreen(props.sm, removeSmPadding)}
          }
        `}
        ${removeMdPadding &&
        css`
          @media screen and (min-width: ${Tokens.breakpoints.laptop}px) {
            ${getCssSizeScreen(props.md, removeMdPadding)}
          }
        `}
        ${removeLgPadding &&
        css`
          @media screen and (min-width: ${Tokens.breakpoints.desktop}px) {
            ${getCssSizeScreen(props.lg, removeLgPadding)}
          }
        `}
      `;
    }
  }}
`;

GridContainer.defaultProps = {
  theme: Tokens.eixods,
};
